import React, { useState } from 'react';
import { apiService } from '../services/api';

const AdminNotificationCreatePage: React.FC = () => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [notificationType, setNotificationType] = useState('Announcement');
  const [priority, setPriority] = useState('Normal');
  const [isActive, setIsActive] = useState(true);
  const [saving, setSaving] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    try {
      await apiService.createAdminNotification({
        title,
        message,
        notificationType,
        priority,
        isActive
      });
      window.location.href = '/admin/notifications';
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold text-gray-900">Create Notification</h1>
      <form onSubmit={submit} className="bg-white shadow rounded-lg p-6 space-y-4 max-w-2xl">
        <div>
          <label className="block text-sm font-medium text-gray-700">Title</label>
          <input className="mt-1 w-full border rounded-md px-3 py-2" value={title} onChange={e=>setTitle(e.target.value)} maxLength={100} required />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700">Message</label>
          <textarea className="mt-1 w-full border rounded-md px-3 py-2" value={message} onChange={e=>setMessage(e.target.value)} maxLength={1000} rows={6} required />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Type</label>
            <select className="mt-1 w-full border rounded-md px-3 py-2" value={notificationType} onChange={e=>setNotificationType(e.target.value)}>
              {['Announcement','Alert','Maintenance','System','Emergency'].map(t=> (
                <option key={t} value={t}>{t}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Priority</label>
            <select className="mt-1 w-full border rounded-md px-3 py-2" value={priority} onChange={e=>setPriority(e.target.value)}>
              {['Low','Normal','High','Urgent'].map(p=> (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
          </div>
          <div className="flex items-center space-x-2 mt-6">
            <input id="active" type="checkbox" checked={isActive} onChange={e=>setIsActive(e.target.checked)} />
            <label htmlFor="active" className="text-sm text-gray-700">Active</label>
          </div>
        </div>
        <div className="pt-4">
          <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Saving...' : 'Create'}</button>
        </div>
      </form>
    </div>
  );
};

export default AdminNotificationCreatePage;


